import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Format, PaymentMethodFormat, DateFormat } from '../common';
import { getPurchaseLogs } from '../../../GraphQL/query/Purchase.query';
import QueryTable from '../../../GraphQL/util/QueryTable';
import COLUMN_TYPE from '../../../Components/Search/SearchFormGenerator/constantType';

const logColumns = [
  {
    Header: 'Reference',
    accessor: 'runningNumber',
    width: 200,
    type: COLUMN_TYPE.STRING,
    isSearchAble: true,
  },
  {
    Header: 'User',
    accessor: 'userName',
    width: 150,
    type: COLUMN_TYPE.STRING,
    isSearchAble: true,
  },
  {
    Header: 'Time stamp',
    accessor: 'createdAt',
    width: 150,
    type: COLUMN_TYPE.DATE,
    isSearchAble: true,
    Cell: ({ value }) => <DateFormat date={value} />,
  },
  {
    Header: 'courseReferId',
    accessor: 'courseReferId',
    width: 150,
    type: COLUMN_TYPE.STRING,
    isSearchAble: true,
  },
  {
    Header: 'fullPrice',
    accessor: 'fullPrice',
    width: 150,
    type: COLUMN_TYPE.NUMBER,
    isSearchAble: true,
    Cell: ({ value }) => <Format amount={value} />,
  },
  {
    Header: 'promotionPrice',
    accessor: 'promotionPrice',
    width: 150,
    type: COLUMN_TYPE.NUMBER,
    isSearchAble: true,
  },
  {
    Header: 'paymentMethod',
    accessor: 'paymentMethod',
    width: 150,
    type: COLUMN_TYPE.STRING,
    isSearchAble: false,
    Cell: ({ original }) => <PaymentMethodFormat method={original} />,
  },
  {
    Header: 'amount',
    accessor: 'amount',
    width: 150,
    type: COLUMN_TYPE.NUMBER,
    isSearchAble: true,
    Cell: ({ value }) => <Format amount={value} />,
  },
  {
    Header: 'taxAmount',
    accessor: 'taxAmount',
    width: 150,
    type: COLUMN_TYPE.NUMBER,
    isSearchAble: true,
    Cell: ({ value }) => <Format amount={value} />,
  },
  {
    Header: 'paidAmount',
    accessor: 'paidAmount',
    width: 150,
    type: COLUMN_TYPE.NUMBER,
    isSearchAble: true,
    Cell: ({ value }) => <Format amount={value} />,
  },
  {
    Header: 'discountCode',
    accessor: 'discountCode',
    width: 150,
    type: COLUMN_TYPE.STRING,
    isSearchAble: true,
    Cell: ({ value }) => <Format amount={value} />,
  },
  {
    Header: 'discountAmount',
    accessor: 'discountAmount',
    width: 150,
    type: COLUMN_TYPE.NUMBER,
    isSearchAble: true,
  },
  {
    Header: 'omiseFee',
    accessor: 'omiseFee',
    width: 150,
    type: COLUMN_TYPE.NUMBER,
    isSearchAble: true,
    Cell: ({ value }) => <Format amount={value} />,
  },
];

class PurchaseLog extends Component {
  state = {
    paging: { currentPage: 0, pageSize: 10 },
    search: {},
  };
  genPaging = (page, pageSize = this.state.paging.pageSize) => {
    return { currentPage: page, pageSize: pageSize };
  };
  genOrder = (sorted) => {
    if (sorted.length > 0) {
      const field = sorted[0].id;
      const type = sorted[0].desc ? 'DESC' : 'ASC';
      return { field, type };
    }
    return;
  };

  handleSearchChange = (search) => {
    const paging = this.genPaging(0);
    this.setState({ search, paging });
  };
  handlePageChange = (page) => {
    const paging = this.genPaging(page);
    this.setState({ paging });
  };
  handlePageSizeChange = (pageSize) => {
    const paging = this.genPaging(0, pageSize);
    this.setState({ paging });
  };
  handleSortedChange = (sorted) => {
    const order = this.genOrder(sorted);
    const paging = this.genPaging(0);
    this.setState({ order, paging });
  };
  render() {
    const { search, paging, order } = this.state;
    return (
      <QueryTable
        type="purchaseLogs"
        columns={logColumns}
        query={getPurchaseLogs}
        search={search}
        onSearchChange={this.handleSearchChange}
        paging={paging}
        onPageChange={this.handlePageChange}
        onPageSizeChange={this.handlePageSizeChange}
        order={order}
        onSortedChange={this.handleSortedChange}
      />
    );
  }
}

export default PurchaseLog;
